import { Injectable, inject } from '@angular/core';

import { PerformanceService } from '@frontend/sports/common/core/utils/performance';
import { DeviceService } from '@frontend/vanilla/core';
import { NgScrollbarOptions, ScrollbarTrack, ScrollbarVisibility } from 'ngx-scrollbar';

@Injectable({ providedIn: 'root' })
export class NgScrollbarOptionsProvider implements NgScrollbarOptions {
    private device = inject(DeviceService);

    visibility: ScrollbarVisibility;
    track: ScrollbarTrack;
    autoHeightDisabled: boolean;

    scrollAuditTime = inject(PerformanceService).isLowTierDevice() ? 20 : 0;

    constructor() {
        this.visibility = this.device.isMobile ? 'native' : 'hover';
        this.track = 'vertical';
        this.autoHeightDisabled = false;
    }
}
